<template>
    <span class="d-inline-block col-5">
        <i class="fas fa-redo hand primary-color" :title="$t('pages.ResetPassword')"  @click="modalShow = !modalShow"></i>
        <b-modal
                ref="createModal"
                size="md"
                :title="$t('pages.ResetPassword')"
                title-tag="h3"
                v-model="modalShow"
        >
            <div class="d-block text-center">
                <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                <div>{{$t('users.ResetPasswordConfirm', {firstName: firstName, lastName: lastName})}}</div>
            </div>

            <div slot="modal-footer" class="w-100 text-right">
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '')"
                        variant="secondary"
                        @click="modalShow = false"
                        :disabled="disabled"
                >
                    {{$t('button.Close')}}
                </b-btn>
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '') + ' ml-3'"
                        variant="danger"
                        @click="submit"
                        :disabled="disabled"
                >
                    {{$t('button.Continue')}}
                </b-btn>
            </div>
        </b-modal>
    </span>
</template>

<script>
  import {BButton} from 'bootstrap-vue/src/components/button/button';
  import {BModal} from 'bootstrap-vue/src/components/modal/modal';
  import { mapActions, mapGetters } from 'vuex';
  import { ROUTER_NAMES, ERROR_MESSAGES } from '../../constants';

  export default {
    name: 'ResetPasswordModal',
    components: {
      BModal: BModal,
      BBtn: BButton
    },
    props: ['firstName', 'lastName', 'userId'],
    data() {
      return {
        modalShow: false,
        disabled: false,
        error: ''
      }
    },
    methods: {
      ...mapActions(['resetUserPassword']),
      submit(e) {
        e.preventDefault();

        this.disabled = true;
        this.error = '';

        this.resetUserPassword({userId: this.userId}).then(() => {
          this.disabled = false;
          this.modalShow = false;
        }, () => {
          this.disabled = false;
          this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
        })
      }
    }
  };
</script>

<style scoped>
</style>
